import React, { useState, useEffect } from 'react';
import '../styles/Popup.css'; // CSSファイルをインポート
import { startDate, endDate, popupImageUrl, popupLinkUrl } from './discountPeriod';

const Popup = ({ excludePages }) => {
  const [isVisible, setIsVisible] = useState(false);

  // 割引期間内か確認
  const isDiscountPeriod = () => {
    const now = new Date();
    return now >= startDate && now < endDate;
  };

  // ポップアップ非表示
  const handleClose = () => {
    setIsVisible(false);
    sessionStorage.setItem('popupDismissed', 'true'); // セッション中非表示フラグを設定
  };

  // ページ除外チェック
  const isExcludedPage = () => {
    const currentUrl = window.location.href;
    return excludePages.some((page) => currentUrl.includes(page));
  };

  useEffect(() => {
    // 割引期間外、除外ページ、またはセッション中に非表示フラグが設定されている場合はポップアップを表示しない
    if (!isDiscountPeriod() || isExcludedPage() || sessionStorage.getItem('popupDismissed') === 'true') {
      return;
    }

    // 2秒後にポップアップ表示
    const timer = setTimeout(() => {
      setIsVisible(true);
    }, 3000);

    return () => clearTimeout(timer); // クリーンアップ
  }, []);

  if (!isVisible) return null;

  const handleOverlayClick = (e) => {
    if (e.target.id === 'popup-overlay') {
      handleClose();
    }
  };

  const handlePopupClick = () => {
    // GTMトリガー発火
    if (window.dataLayer) {
      window.dataLayer.push({
        event: 'popup_click',
        popupImageUrl: popupImageUrl,
        popupLinkUrl: popupLinkUrl,
        timestamp: new Date().toISOString()
      });
    }


    window.location.href = popupLinkUrl;
  };

  return (
    <div
      id="popup-overlay"
      className="overlay"
      onClick={handleOverlayClick}
    >
      <div className="popupContainer popup-animation">
        <button className="closeButton popup-animation" onClick={handleClose}>
          ×
        </button>
        <div
          className="popup popup-animation"
          onClick={handlePopupClick}
        >
          <img
            src={popupImageUrl}
            alt="キャンペーン"
            className="image"
          />
        </div>
      </div>
    </div>
  );
};

export default Popup;


